/**
 * Enemy abilities shown for the current level (GDD §7.2; judgment calls 5 and 33). Names and order are the concept's
 * (threatList, L873–L881); each unlocks at the level config.difficulty gives it, and firing threats are red.
 */
import { config } from '../core/config.ts';

export interface Ability {
  text: string;
  /** First level with it. */
  from: number;
  /** A firing threat (shown red). */
  fire: boolean;
}

const d = config.difficulty;

export const ABILITIES: readonly Ability[] = [
  { text: 'HELIS MOVE', from: d.heliPatrol.fromLevel, fire: false },
  { text: 'SHIPS MOVE', from: d.gunboatPatrol.fromLevel, fire: false },
  { text: 'ENEMY JETS', from: d.jets.fromLevel, fire: false },
  { text: 'BRIDGE GUNS', from: d.bridgeGunsFromLevel, fire: true },
  { text: 'HELIS FIRE', from: d.heliFire.fromLevel, fire: true },
  { text: 'FLAK', from: d.gunboatFlak.fromLevel, fire: true },
  // "MORE ENEMIES · FASTER FIRE" follows the last named level banner (GDD §6.2), as in the concept.
  { text: 'FASTER FIRE', from: config.text.levelBanners.length + 1, fire: true },
];

/** The abilities at level L, in the concept's order. */
export function abilitiesAt(L: number): Ability[] {
  return ABILITIES.filter((a) => L >= a.from);
}
